import { Stack, Typography } from "@mui/material";

const PassthroughConfigurationHeader = () => {
  return (
    <Stack spacing={2}>
      <Typography variant="subtitle2">Settings</Typography>
      <Typography color="secondary">
        To create or find your API Key, head over to the &apos;API keys&apos; section on your Passthrough organization
        settings page.
      </Typography>
    </Stack>
  );
};

export default PassthroughConfigurationHeader;
